import { UnifiedLightboxTrackingEvents } from '@components/unified-lightbox/hooks/use-track-unified-lightbox';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import useTrackQuickLinksInteraction, {
	getQuickLinkSourceContent,
} from './hooks/use-track-quick-links-interaction';
import { MobileGalleryQuickLinkItem } from './quick_link_item';

interface StateProps {
	vendor: Vendor.Decorated;
}

interface OwnProps {
	mediaBuckets: [Vendor.MediaType, Vendor.Media[]][];
	context?: ReturnType<typeof useInlineRfqForm>;
	trackingEvents?: UnifiedLightboxTrackingEvents;
}

type MobileGalleryQuickLinkCollectionProps = StateProps & OwnProps;

const MobileGalleryQuickLinkCollection: FC<
	MobileGalleryQuickLinkCollectionProps
> = (props) => {
	const { mediaBuckets, vendor, trackingEvents } = props;

	const trackQuickLinkInteraction = useTrackQuickLinksInteraction(vendor);

	const trackQuicklinksClick = (type: Vendor.MediaType) => {
		if (trackingEvents?.onGalleryOpenCallback === undefined) {
			trackQuickLinkInteraction(getQuickLinkSourceContent(type));
		}
	};

	return (
		<>
			{mediaBuckets.map(([, mediaBucket]) => {
				const mediaItem = mediaBucket && mediaBucket[0];
				if (!mediaItem) {
					return null;
				}

				return (
					<MobileGalleryQuickLinkItem
						key={`quick-link-${mediaItem.mediaType}S`}
						trackQuicklinksClick={trackQuicklinksClick}
						mediaBucket={mediaBucket}
						context={props.context}
						trackingEvents={trackingEvents}
					/>
				);
			})}
		</>
	);
};

const mapStateToProps = (state: Redux.State): StateProps => ({
	vendor: state.vendor.vendor as Vendor.Decorated,
});

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(
	MobileGalleryQuickLinkCollection,
);
